module.exports = __webpack_public_path__ + "img/流泪.4e362fd2.png";